import React, { useEffect, useState } from 'react';
import Main from '../components/admin/Main';
import PageContainer from '../components/admin/PageContainer';
import Modal from '../components/admin/Modal';
import CollapseCard from '../components/admin/CollapseCard';
import OrderItemForm from '../components/admin/OrderItemForm';
import OrderItemList from '../components/admin/OrderItemList';

// Import your API service
import { fetchOrderItems, createOrderItems, updateOrderItems, deleteOrderItems } from '../service/OrederItemService';

const OrderItemPage = () => {
  const [showModal, setShowModal] = useState(false);
  const [ordereditem, setordereditem] = useState([]);
  const [selectorderitem, setselectorderitem] = useState(null);

  // Fetch data on mount
  const fetchdData = async () => {
    try {
      const data = await fetchOrderItems();
      setordereditem(data);
    } catch (error) {
      console.error('Failed to fetch order items:', error);
    }
  };

  useEffect(() => {
    fetchdData();
  }, []);

  // Handle Create or Update
  const handleSave = async (formData) => {
    try {
      if (selectorderitem) {
        // Update existing
        await updateOrderItems(selectorderitem.id, formData);
      } else {
        // Create new
        await createOrderItems(formData);
      }
      // Refresh list after save
      await fetchdData();
      setShowModal(false);
      setselectorderitem(null); // Reset selection
    } catch (error) {
      console.error('Save failed:', error);
    }
  };

  // Handle Delete
  const handleDelete = async (id) => {
    try {
      await deleteOrderItems(id);
      // Update state after deletion
      setordereditem((prev) => prev.filter((item) => item.id !== id));
    } catch (error) {
      console.error('Delete failed:', error);
    }
  };

  return (
    <Main>
      <PageContainer
        title="Order Items"
        // buttonText="Add Order Item"
        // onButtonClick={() => {
        //   setselectorderitem(null);
        //   setShowModal(true);
        // }}
      >
        {/* Modal for Add/Edit */}
        <Modal
          visible={showModal}
          size="lg"
          onClose={() => setShowModal(false)}
          headerText={selectorderitem ? "Edit Order Item" : "Add Order Item"}
          centered
        >
          <OrderItemForm
            onSave={handleSave}
            selectorderitem={selectorderitem}
          />
        </Modal>

        {/* List of Items */}
        <CollapseCard title="Order Items List">
          <OrderItemList
            ordereditem={ordereditem}
            onEdit={(item) => {
              setselectorderitem(item);
              setShowModal(true);
            }}
            onDelete={handleDelete}
          />
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default OrderItemPage;